var path = 'pages/search.html';
var html = "<header id=general-searchBar class=animate--fill> <search class=search-full data-keep-open-on-blur data-add-classes=\"search--custom search--navbar\" data-supplier=userSearchSupplier data-callback=visitUserProfile(selected) data-search-template=user data-input-i18n-attr=menu.search|placeholder id=general-searchBar-search> </search> </header> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/pages/search.html
// module id = gbXM
// module chunks = 1